<span
  class="metric-value"
  [class.metric-null]="value() === null"
  [class.metric-zero]="value() === 0"
  [class.text-ui-red-300]="value() === 0"
  [matTooltip]="tooltip() ?? ''"
  [matTooltipDisabled]="!tooltip()"
>{{ displayText() }}</span>
@if (showEstimatedBadge()) {
  <span class="metric-cell-estimated-badge text-[10px] font-semibold uppercase text-ui-gray-dark ml-1">Estimated</span>
}
